/* global turnstile */
document.addEventListener('alpine:init', () => {
    Alpine.data('helpForm', () => ({
        activeTab: 1,
        activeSubTab: '1_1',
        nextTab: 1,
        nextSubTab: '1_2',

        showErrorName: false,
        showErrorPhone: false,
        showErrorEmail: false,
        showErrorCompany: false,
        loading: false,

        formName: '',
        formEmail: '',
        formPhone: '',
        formCompany: '',

        // Need this for some form stuff
        init() {

            // Generate a new token for Cloudflare when we restart
            /*this.$watch('activeTab', (value) => {
             if (value === 0 && typeof turnstile !== 'undefined') {
             const turnstileDiv = document.querySelector('.cf-turnstile');

             if (turnstileDiv) {
             // Clear content first
             turnstileDiv.innerHTML = '';

             // Render a new widget
             turnstile.render(turnstileDiv, {
             sitekey: '0x4AAAAAABbkN0DwIZjEXoV0',
             theme: 'light',
             callback: 'onTurnstileSuccess'
             });
             }
             }
             });*/
        },

        // validateFields(selectors = []) {
        //     const requiredFields = selectors
        //         .map(selector => document.querySelector(selector))
        //         .filter(el => el && el.offsetParent !== null);
        //
        //     let isValid = true;
        //
        //     // Nollställ först
        //    this.showErrorName = false;
        //     this.showErrorPhone = false;
        //     this.showErrorEmail = false;
        //     this.showErrorCompany = false;
        //
        //     requiredFields.forEach(field => {
        //         const valueMissing = !field.value || (field.type === 'number' && parseInt(field.value) <= 0);
        //         const dataId = field.dataset.id;
        //
        //         if (field.type === 'email' && !this.isValidEmail(field.value)) {
        //             field.classList.add('border-red-600');
        //             isValid = false;
        //
        //             // Sätt felmeddelande för ogiltig e-postadress
        //             if (dataId === 'email-help') this.showErrorEmail = true;
        //         }
        //
        //         if (valueMissing && !this.isValidEmail(field.value)) {
        //             field.classList.add('border-red-600');
        //             isValid = false;
        //
        //             // Sätt rätt flagga
        //            if (dataId === 'name-help') this.showErrorName = true;
        //             if (dataId === 'phone-help') this.showErrorPhone = true;
        //             if (dataId === 'email-help') this.showErrorEmail = true;
        //             if (dataId === 'company-help') this.showErrorCompany = true;
        //         } else {
        //             field.classList.remove('border-red-600');
        //         }
        //
        //     });
        //
        //     return isValid;
        // },

        validateFields(selectors = []) {
            const requiredFields = selectors
                .map(selector => document.querySelector(selector))
                .filter(el => el && el.offsetParent !== null);

            let isValid = true;

            // Reset error flags
            this.showErrorName = false;
            this.showErrorPhone = false;
            this.showErrorEmail = false;
            this.showErrorCompany = false;

            requiredFields.forEach(field => {
                const value = field.value?.trim() || '';
                const dataId = field.dataset.id;

                switch (dataId) {
                    case 'email-help':
                        if (!this.isValidEmail(value)) {
                            field.classList.add('border-red-600');
                            this.showErrorEmail = true;
                            isValid = false;
                        } else {
                            field.classList.remove('border-red-600');
                        }
                        break;

                    case 'name-help':
                    case 'phone-help':
                    case 'company-help':
                        if (value === '') {
                            field.classList.add('border-red-600');
                            isValid = false;

                            switch (dataId) {
                                case 'name-help':
                                    this.showErrorName = true;
                                    break;
                                case 'phone-help':
                                    this.showErrorPhone = true;
                                    break;
                                case 'company-help':
                                    this.showErrorCompany = true;
                                    break;
                            }
                        } else {
                            field.classList.remove('border-red-600');
                        }
                        break;

                    default:
                        // Unknown field, ignore
                        break;
                }
            });

            return isValid;
        },

        isValidEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailPattern.test(email);
        },

        nextStepHelp() {
            if (this.activeSubTab === '1_1') {
                this.activeSubTab = '1_2';

                track({
                    event: 'help_step',
                    step: 'step_2',
                    direction: 'forward',
                });

            } else if (this.activeSubTab === '1_2') {
                this.handleFinalStep('help');
            }
        },

        prevStepHelp() {
            if (this.activeSubTab === '1_2') {
                this.activeSubTab = '1_1';

                track({
                    event: 'help_step',
                    step: 'step_1',
                    direction: 'backward',
                });
            } else if (this.activeSubTab === '1_1') {
                this.activeTab = 0;

                track({
                    event: 'help_step',
                    step: 'initial',
                    direction: 'backward',
                });
            }
        },

        collectFormData(formId) {
            const formElement = document.querySelector(formId);
            if (formElement) {
                return new FormData(formElement);
            }

            return null;
        },

        async handleFinalStep(type) {
            this.loading = true; // DISABLE BUTTON

            let fieldsToValidate = [];
            let submitFunction = null;

            if (type === 'help') {
                fieldsToValidate = [
                    '[data-id=name-help]',
                    '[data-id=email-help]',
                    '[data-id=phone-help]',
                    '[data-id=company-help]',
                ];

                submitFunction = this.handleHelpForm;
            } else {
                console.error('Okänd formtyp:', type);
                return;
            }

            if (!this.validateFields(fieldsToValidate)) {
                this.loading = false; // Validation failed -> Re-enable button
                return;
            }

            try {
                const result = await submitFunction.call(this);
                this.activeTab = result ? 3 : 4;

                if (result) {

                }

            } catch (error) {
                console.error('Fel vid inskick:', error);
            } finally {
                this.loading = false; // ENABLE BUTTON?
            }
        },

        resetForm(formId) {
            const form = document.querySelector(formId);
            if (!form) {
                return;
            }

            // Töm alla inputs, textareas och selects
            form.querySelectorAll('input, textarea').forEach(input => {
                if (input.type === 'checkbox') {
                    input.checked = false;
                } else {
                    input.value = '';
                }
            });

            // Nollställ alla felklasser
            form.querySelectorAll('.border-red-600').forEach(el => {
                el.classList.remove('border-red-600');
            });

        },

        async handleHelpForm() {
            const helpFormData = this.collectFormData('#helpForm');

            if (!helpFormData) {
                console.error('Kunde inte hitta formuläret #helpForm');

                return false;
            }

            helpFormData.append('action', 'help_form');

            // Cloudflare Turnstile
            /*const turnstileToken = document.querySelector('[name="cf-turnstile-response"]');
             if (!turnstileToken) {
             console.error("Bekräfta att du inte är en robot.");

             return;
             }

             helpFormData.append("turnstile_token", turnstileToken.value);*/

            try {
                let response = await fetch(appAjax.ajax_url, {
                    method: 'POST',
                    body: helpFormData,
                });

                if (!response.ok) {
                    throw new Error('Nätverksfel vid skickande');
                }

                let result = await response.json();
                console.log('Svar från server:', result);

                if (result.success === false) {
                    throw new Error('Formulärfel från servern');
                }

                track({
                    event: 'help_finish',
                    form: 'help',
                });

                return result.success !== false;
            } catch (error) {
                console.error('Fel vid skickande:', error);

                return false;
            }
        },

        isFormReady() {
            return (
                this.formName.trim() !== '' &&
                this.formPhone.trim() !== '' &&
                this.formCompany.trim() !== '' &&
                this.isValidEmail(this.formEmail)
            );
        },

    }));
});

//# sourceMappingURL=help-form.js.map
